import { render, staticRenderFns } from "./LayoutReports.vue?vue&type=template&id=97b4ac60&scoped=true"
import script from "./LayoutReports.vue?vue&type=script&lang=js"
export * from "./LayoutReports.vue?vue&type=script&lang=js"
import style0 from "./LayoutReports.vue?vue&type=style&index=0&id=97b4ac60&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b4ac60",
  null
  
)

export default component.exports